module.exports = __webpack_public_path__ + "img/info.cbdcb2f2.png";